export default function EmptyState({ isDarkMode, icon: Icon, title, hint }) {
  return (
    <div className="text-center py-24" data-testid="market-empty-state">
      <div className={`inline-flex items-center justify-center w-16 h-16 rounded-2xl mb-4 border ${isDarkMode ? 'bg-[#1E9BD9]/10 border-[#1E9BD9]/20' : 'bg-[#1E9BD9]/5 border-[#1E9BD9]/20'}`}>
        <Icon className="h-7 w-7 text-[#1E9BD9]" />
      </div>
      <p className={`text-lg font-semibold mb-2 ${isDarkMode ? 'text-white' : 'text-slate-900'}`}>{title}</p>
      <p className={`text-sm ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>{hint}</p>
    </div>
  );
}
